import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import HelpText from 'components/HelpText';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import { required, optional } from '../../../../../utils/validation/validator';
import Validate from '../../../../../components/Validation/Validate';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import CurrencySelector from '../../../components/CurrencySelector';

export class DelayedTravelExpensesListItem extends React.Component {
  state = {
    item: {
      id: this.props.item.id, // key for update and remove (auto generated)
      date: this.props.item.date,
      description: this.props.item.description,
      amount: this.props.item.amount,
      amountCurrency: this.props.item.amountCurrency,
      amountRefunded: this.props.item.amountRefunded,
      amountRefundedCurrency: this.props.item.amountRefundedCurrency,
      amountClaimed: this.props.item.amountClaimed,
      amountClaimedCurrency: this.props.item.amountClaimedCurrency,
    },
  };

  onDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove && this.props.total > 1) {
      this.props.onRemove(this.props.item.id);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };


  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;
    const refundFieldValidator = item.amountRefunded > 0 ? required : optional;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto mb02">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto mb02">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.delayedTravelExpenseTitle}
                values={{ index: this.props.index + 1 }}
              />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-3 col-sm-4 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.date}
              fieldName={messages.delayedTravelExpenseDate}
            >
              <DatePicker
                position={'top-start'}
                disabled={disabled}
                type="text"
                onDayChange={this.onDayChange('date')}
                value={item.date}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.delayedTravelExpenseDate}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-9 col-sm-8 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.description}
              fieldName={messages.delayedTravelExpenseDescription}
            >
              <Textbox
                disabled={disabled}
                type="text"
                onChange={this.onChange('description')}
                value={item.description}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.delayedTravelExpenseDescription}
                />
              </ErrorMessage>
            </Validate>
            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Food or Accommodation' }}
              />
            </HelpText>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6 col-sm-6 mb02">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amount}
                fieldName={messages.delayedTravelExpenseAmount}
              >
                <Textbox
                  type="number"
                  onChange={this.onChange('amount')}
                  value={item.amount}
                  disabled={disabled}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.delayedTravelExpenseAmount}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-6 col-sm-6 mb02">
            <FlexBox direction="column">
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amountCurrency}
                fieldName={messages.delayedTravelExpenseCurrency}
              >

                <CurrencySelector
                  onChange={this.handleCurrencyChange('amountCurrency')}
                  disabled={disabled}
                  value={item.amountCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.delayedTravelExpenseCurrency}
                  />
                </ErrorMessage>
              </Validate>
              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-3 col-sm-3">
            {item.amountRefunded > 0 && <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.dateRefundWasReceived}
                fieldName={messages.dateRefundWasReceived}
              >
                <DatePicker
                  position={'top-start'}
                  disabled={disabled}
                  type="text"
                  onDayChange={this.onDayChange('dateRefundWasReceived')}
                  value={item.dateRefundWasReceived}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateRefundWasReceived}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>}
            {(!item.amountRefunded || item.amountRefunded <= 0) && <FlexBox>
              <PageSectionHeader>
                <FormattedMessage
                  {...messages.dateRefundWasReceived}
                />
              </PageSectionHeader>
              <DatePicker
                position={'top-start'}
                disabled={disabled}
                type="text"
                onDayChange={this.onDayChange('dateRefundWasReceived')}
                value={item.dateRefundWasReceived}
                placeholder=""
              />
            </FlexBox>}
          </div>
          <div className="form-group col-md-6 col-sm-6 mt-md-3">
            <FlexBox>
              <PageSectionHeader>
                <FormattedMessage
                  {...messages.delayedTravelExpenseAmountRefunded}
                />
              </PageSectionHeader>
              <Textbox
                style={{ marginTop: '2px' }}
                type="number"
                onChange={this.onChange('amountRefunded')}
                value={item.amountRefunded}
                disabled={disabled}
              />
              <HelpText>
                <FormattedMessage
                  {...messages.ifNoAmountRefundedThenEnterZero}
                />
              </HelpText>
            </FlexBox>
          </div>
          <div className="form-group col-md-3 col-sm-3 mt-md-3">
            {item.amountRefunded > 0 && <FlexBox direction="column">
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[refundFieldValidator]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amountRefundedCurrency}
                fieldName={messages.delayedTravelExpenseCurrency}
              >
                <CurrencySelector
                  style={{ marginTop: '2px' }}
                  onChange={this.handleCurrencyChange('amountRefundedCurrency')}
                  disabled={disabled}
                  value={item.amountRefundedCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.delayedTravelExpenseCurrency}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>}

            {(!item.amountRefunded || item.amountRefunded <= 0) && <FlexBox direction="column">
              <PageSectionHeader>
                <FormattedMessage
                  {...messages.delayedTravelExpenseCurrency}
                />
              </PageSectionHeader>
              <div>
                <CurrencySelector
                  style={{ marginTop: '2px' }}
                  onChange={this.handleCurrencyChange('amountRefundedCurrency')}
                  disabled={disabled}
                  value={item.amountRefundedCurrency}
                />
              </div>
              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>}
          </div>
        </div>
      </div>
    );
  }
}

DelayedTravelExpensesListItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  total: PropTypes.number,
  disabled: PropTypes.bool,
  removable: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step6/components/DelayedTravelExpenses/DelayedTravelExpensesListItem.js